import { Link } from "react-router-dom";
import { PRODUCT_NAME, COMPANY } from "@/config";

export const PublicFooter = () => (
  <footer data-testid="public-footer" className="border-t border-black/5 bg-white">
    <div className="max-w-6xl mx-auto px-6 py-12 grid sm:grid-cols-4 gap-8 text-sm">
      <div>
        <span className="font-serif text-xl font-extrabold text-ink">{PRODUCT_NAME}<span className="text-coral-strong">.</span></span>
        <p className="text-slate-400 mt-2 text-xs">Votre voix, amplifiée. Édité par {COMPANY}.</p>
      </div>
      <div>
        <p className="font-bold text-ink mb-3">Produit</p>
        <ul className="space-y-2 text-slate-500">
          <li><a href="/#fonctionnalites" className="hover:text-coral-dark">Fonctionnalités</a></li>
          <li><a href="/#tarifs" className="hover:text-coral-dark">Tarifs</a></li>
          <li><a href="/#faq" className="hover:text-coral-dark">FAQ</a></li>
        </ul>
      </div>
      <div>
        <p className="font-bold text-ink mb-3">Programme</p>
        <ul className="space-y-2 text-slate-500">
          <li><Link to="/login?register=1" className="hover:text-coral-dark">Devenir affilié</Link></li>
          <li><Link to="/login" className="hover:text-coral-dark">Se connecter</Link></li>
        </ul>
      </div>
      <div>
        <p className="font-bold text-ink mb-3">Légal</p>
        <ul className="space-y-2 text-slate-500">
          <li><Link to="/mentions" className="hover:text-coral-dark">Mentions légales</Link></li>
          <li><Link to="/cgu" className="hover:text-coral-dark">CGU / CGV</Link></li>
          <li><Link to="/confidentialite" data-testid="footer-privacy-link" onClick={() => window.scrollTo(0, 0)} className="hover:text-coral-dark">Confidentialité</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-black/5 py-5 text-center text-xs text-slate-400">
      © {new Date().getFullYear()} {PRODUCT_NAME}, <a href="https://apollo.fr" className="hover:text-coral-dark">by {COMPANY}</a>
    </div>
  </footer>
);

export const PrivacyConsent = () => (
  <p data-testid="signup-privacy-consent" className="text-xs text-slate-500 mt-3 text-center">
    En créant un compte, vous acceptez notre{" "}
    <Link to="/confidentialite" data-testid="signup-privacy-link" className="text-coral-dark font-semibold hover:underline">politique de confidentialité</Link>.
  </p>
);

export default PublicFooter;
